import React, { useState } from "react";
import TableDisplay from "./TableDisplay";
import * as Yup from "yup";

export default function VcVideo() {
  const [title, setTitle] = useState(["id", "video", "status"]);
  const formConfig = {
    fields: [
      {
        name: "video",
        label: "vc Video",
        type: "video",
      },
      {
        name: "status",
        label: "Status",
        type: "switch",
      },
    ],
    validationSchema: Yup.object({
      video: Yup.mixed().required("Please upload an image."),
    }),
  };
  const initialValues = {
    video: "",
    status: 0,
  };
  return (
    <div>
      <TableDisplay
        category="VC Video Data"
        tableurl="admin-get-vcvideo"
        title={title}
        deleteurl="admin-delete-vcvideo"
        deleteallurl="admin-all-delete-vcvideo"
        addurl="add-vcvideo"
        formConfig={formConfig}
        initialValues={initialValues}
        updateurl="get-edit-vcvideo"
        updatteurl="admin-edit-vcvideo"
        statusurl="admin-status-vcvideo"
        axiosHeader={true}
      />
    </div>
  );
}
